import React, { Component } from 'react';
import './dockedMenuInner.scss';
import PopupFilledHeader from './popupFilledHeader';

class DockedMenuInner extends Component {
    render() {
        return (
            <div className="docked-menu-inner">
                <PopupFilledHeader title={this.props.title} logo={this.props.logo} close={this.props.close} />
                <div className="dm-body">
                    {this.props.children}
                </div>
            </div>
        )
    }
}
export default DockedMenuInner;